import { __commonJS } from "./chunk-B4qE4VCv.mjs";
import { require_function } from "./function-CN-GVuiB.mjs";

//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/internal.js
var require_internal = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/internal.js": ((exports) => {
	var __spreadArray = exports && exports.__spreadArray || function(to, from, pack) {
		if (pack || arguments.length === 2) {
			for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
				if (!ar) ar = Array.prototype.slice.call(from, 0, i);
				ar[i] = from[i];
			}
		}
		return to.concat(ar || Array.prototype.slice.call(from));
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.flatMapReader = exports.flatMapTask = exports.flatMapIO = exports.flatMapEither = exports.flatMapOption = exports.flatMapNullable = exports.liftOption = exports.liftNullable = exports.fromReadonlyNonEmptyArray = exports.has = exports.emptyRecord = exports.emptyReadonlyArray = exports.tail = exports.head = exports.isNonEmpty = exports.singleton = exports.right = exports.left = exports.isRight = exports.isLeft = exports.some = exports.none = exports.isSome = exports.isNone = void 0;
	var function_1$2 = require_function();
	/** @internal */
	var isNone = function(fa) {
		return fa._tag === "None";
	};
	exports.isNone = isNone;
	/** @internal */
	var isSome = function(fa) {
		return fa._tag === "Some";
	};
	exports.isSome = isSome;
	/** @internal */
	exports.none = { _tag: "None" };
	/** @internal */
	var some = function(a) {
		return {
			_tag: "Some",
			value: a
		};
	};
	exports.some = some;
	/** @internal */
	var isLeft = function(ma) {
		return ma._tag === "Left";
	};
	exports.isLeft = isLeft;
	/** @internal */
	var isRight = function(ma) {
		return ma._tag === "Right";
	};
	exports.isRight = isRight;
	/** @internal */
	var left = function(e) {
		return {
			_tag: "Left",
			left: e
		};
	};
	exports.left = left;
	/** @internal */
	var right = function(a) {
		return {
			_tag: "Right",
			right: a
		};
	};
	exports.right = right;
	/** @internal */
	var singleton = function(a) {
		return [a];
	};
	exports.singleton = singleton;
	/** @internal */
	var isNonEmpty = function(as$1) {
		return as$1.length > 0;
	};
	exports.isNonEmpty = isNonEmpty;
	/** @internal */
	var head = function(as$1) {
		return as$1[0];
	};
	exports.head = head;
	/** @internal */
	var tail = function(as$1) {
		return as$1.slice(1);
	};
	exports.tail = tail;
	/** @internal */
	exports.emptyReadonlyArray = [];
	/** @internal */
	exports.emptyRecord = {};
	/** @internal */
	exports.has = Object.prototype.hasOwnProperty;
	/** @internal */
	var fromReadonlyNonEmptyArray = function(as$1) {
		return __spreadArray([as$1[0]], as$1.slice(1), true);
	};
	exports.fromReadonlyNonEmptyArray = fromReadonlyNonEmptyArray;
	/** @internal */
	var liftNullable = function(F) {
		return function(f, onNullable) {
			return function() {
				var a = [];
				for (var _i = 0; _i < arguments.length; _i++) a[_i] = arguments[_i];
				var o = f.apply(void 0, a);
				return F.fromEither(o == null ? (0, exports.left)(onNullable.apply(void 0, a)) : (0, exports.right)(o));
			};
		};
	};
	exports.liftNullable = liftNullable;
	/** @internal */
	var liftOption = function(F) {
		return function(f, onNone) {
			return function() {
				var a = [];
				for (var _i = 0; _i < arguments.length; _i++) a[_i] = arguments[_i];
				var o = f.apply(void 0, a);
				return F.fromEither((0, exports.isNone)(o) ? (0, exports.left)(onNone.apply(void 0, a)) : (0, exports.right)(o.value));
			};
		};
	};
	exports.liftOption = liftOption;
	/** @internal */
	var flatMapNullable = function(F, M) {
		return /* @__PURE__ */ (0, function_1$2.dual)(3, function(self, f, onNullable) {
			return M.flatMap(self, (0, exports.liftNullable)(F)(f, onNullable));
		});
	};
	exports.flatMapNullable = flatMapNullable;
	/** @internal */
	var flatMapOption = function(F, M) {
		return /* @__PURE__ */ (0, function_1$2.dual)(3, function(self, f, onNone) {
			return M.flatMap(self, (0, exports.liftOption)(F)(f, onNone));
		});
	};
	exports.flatMapOption = flatMapOption;
	/** @internal */
	var flatMapEither = function(F, M) {
		return /* @__PURE__ */ (0, function_1$2.dual)(2, function(self, f) {
			return M.flatMap(self, function(a) {
				return F.fromEither(f(a));
			});
		});
	};
	exports.flatMapEither = flatMapEither;
	/** @internal */
	var flatMapIO = function(F, M) {
		return /* @__PURE__ */ (0, function_1$2.dual)(2, function(self, f) {
			return M.flatMap(self, function(a) {
				return F.fromIO(f(a));
			});
		});
	};
	exports.flatMapIO = flatMapIO;
	/** @internal */
	var flatMapTask = function(F, M) {
		return /* @__PURE__ */ (0, function_1$2.dual)(2, function(self, f) {
			return M.flatMap(self, function(a) {
				return F.fromTask(f(a));
			});
		});
	};
	exports.flatMapTask = flatMapTask;
	/** @internal */
	var flatMapReader = function(F, M) {
		return /* @__PURE__ */ (0, function_1$2.dual)(2, function(self, f) {
			return M.flatMap(self, function(a) {
				return F.fromReader(f(a));
			});
		});
	};
	exports.flatMapReader = flatMapReader;
}) });

//#endregion
//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Apply.js
var require_Apply = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Apply.js": ((exports) => {
	var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = exports && exports.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ap = ap;
	exports.apFirst = apFirst;
	exports.apSecond = apSecond;
	exports.apS = apS;
	exports.getApplySemigroup = getApplySemigroup;
	exports.sequenceT = sequenceT;
	exports.sequenceS = sequenceS;
	/**
	* The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
	*
	* `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
	* `f`.
	*
	* Instances must satisfy the following law in addition to the `Functor` laws:
	*
	* 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
	*
	* Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
	*
	* @example
	* import * as O from 'fp-ts/Option'
	* import { pipe } from 'fp-ts/function'
	*
	* const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
	* const fa: O.Option<string> = O.some('s')
	* const fb: O.Option<number> = O.some(1)
	* const fc: O.Option<boolean> = O.some(true)
	*
	* assert.deepStrictEqual(
	*   pipe(
	*     // lift a function
	*     O.some(f),
	*     // apply the first argument
	*     O.ap(fa),
	*     // apply the second argument
	*     O.ap(fb),
	*     // apply the third argument
	*     O.ap(fc)
	*   ),
	*   O.some('s1true')
	* )
	*
	* @since 2.0.0
	*/
	var function_1$1 = require_function();
	var _ = __importStar(require_internal());
	function ap(F, G) {
		return function(fa) {
			return function(fab) {
				return F.ap(F.map(fab, function(gab) {
					return function(ga) {
						return G.ap(gab, ga);
					};
				}), fa);
			};
		};
	}
	function apFirst(A) {
		return function(second) {
			return function(first) {
				return A.ap(A.map(first, function(a) {
					return function() {
						return a;
					};
				}), second);
			};
		};
	}
	function apSecond(A) {
		return function(second) {
			return function(first) {
				return A.ap(A.map(first, function() {
					return function(b) {
						return b;
					};
				}), second);
			};
		};
	}
	function apS(F) {
		return function(name, fb) {
			return function(fa) {
				return F.ap(F.map(fa, function(a) {
					return function(b) {
						var _a;
						return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
					};
				}), fb);
			};
		};
	}
	function getApplySemigroup(F) {
		return function(S) {
			return { concat: function(first, second) {
				return F.ap(F.map(first, function(x) {
					return function(y) {
						return S.concat(x, y);
					};
				}), second);
			} };
		};
	}
	function curried(f, n, acc) {
		return function(x) {
			var combined = Array(acc.length + 1);
			for (var i = 0; i < acc.length; i++) combined[i] = acc[i];
			combined[acc.length] = x;
			return n === 0 ? f.apply(null, combined) : curried(f, n - 1, combined);
		};
	}
	var tupleConstructors = {
		1: function(a) {
			return [a];
		},
		2: function(a) {
			return function(b) {
				return [a, b];
			};
		},
		3: function(a) {
			return function(b) {
				return function(c) {
					return [
						a,
						b,
						c
					];
				};
			};
		},
		4: function(a) {
			return function(b) {
				return function(c) {
					return function(d) {
						return [
							a,
							b,
							c,
							d
						];
					};
				};
			};
		},
		5: function(a) {
			return function(b) {
				return function(c) {
					return function(d) {
						return function(e) {
							return [
								a,
								b,
								c,
								d,
								e
							];
						};
					};
				};
			};
		}
	};
	function getTupleConstructor(len) {
		if (!_.has.call(tupleConstructors, len)) tupleConstructors[len] = curried(function_1$1.tuple, len - 1, []);
		return tupleConstructors[len];
	}
	function sequenceT(F) {
		return function() {
			var args = [];
			for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
			var len = args.length;
			var f = getTupleConstructor(len);
			var fas = F.map(args[0], f);
			for (var i = 1; i < len; i++) fas = F.ap(fas, args[i]);
			return fas;
		};
	}
	function getRecordConstructor(keys) {
		var len = keys.length;
		switch (len) {
			case 1: return function(a) {
				var _a;
				return _a = {}, _a[keys[0]] = a, _a;
			};
			case 2: return function(a) {
				return function(b) {
					var _a;
					return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
				};
			};
			case 3: return function(a) {
				return function(b) {
					return function(c) {
						var _a;
						return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
					};
				};
			};
			case 4: return function(a) {
				return function(b) {
					return function(c) {
						return function(d) {
							var _a;
							return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
						};
					};
				};
			};
			case 5: return function(a) {
				return function(b) {
					return function(c) {
						return function(d) {
							return function(e) {
								var _a;
								return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
							};
						};
					};
				};
			};
			default: return curried(function() {
				var args = [];
				for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
				var r = {};
				for (var i = 0; i < len; i++) r[keys[i]] = args[i];
				return r;
			}, len - 1, []);
		}
	}
	function sequenceS(F) {
		return function(r) {
			var keys = Object.keys(r);
			var len = keys.length;
			var f = getRecordConstructor(keys);
			var fr = F.map(r[keys[0]], f);
			for (var i = 1; i < len; i++) fr = F.ap(fr, r[keys[i]]);
			return fr;
		};
	}
}) });

//#endregion
//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Chain.js
var require_Chain = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Chain.js": ((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.chainFirst = chainFirst;
	exports.tap = tap;
	exports.bind = bind;
	function chainFirst(M) {
		var tapM = tap(M);
		return function(f) {
			return function(first) {
				return tapM(first, f);
			};
		};
	}
	/** @internal */
	function tap(M) {
		return function(first, f) {
			return M.chain(first, function(a) {
				return M.map(f(a), function() {
					return a;
				});
			});
		};
	}
	function bind(M) {
		return function(name, f) {
			return function(ma) {
				return M.chain(ma, function(a) {
					return M.map(f(a), function(b) {
						var _a;
						return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
					});
				});
			};
		};
	}
}) });

//#endregion
//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Functor.js
var require_Functor = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Functor.js": ((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.map = map;
	exports.flap = flap;
	exports.bindTo = bindTo;
	exports.let = let_;
	exports.getFunctorComposition = getFunctorComposition;
	exports.as = as;
	exports.asUnit = asUnit;
	/**
	* A `Functor` is a type constructor which supports a mapping operation `map`.
	*
	* `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
	* constructor `f` to represent some computational context.
	*
	* Instances must satisfy the following laws:
	*
	* 1. Identity: `F.map(fa, a => a) <-> fa`
	* 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
	*
	* @since 2.0.0
	*/
	var function_1 = require_function();
	function map(F, G) {
		return function(f) {
			return function(fa) {
				return F.map(fa, function(ga) {
					return G.map(ga, f);
				});
			};
		};
	}
	function flap(F) {
		return function(a) {
			return function(fab) {
				return F.map(fab, function(f) {
					return f(a);
				});
			};
		};
	}
	function bindTo(F) {
		return function(name) {
			return function(fa) {
				return F.map(fa, function(a) {
					var _a;
					return _a = {}, _a[name] = a, _a;
				});
			};
		};
	}
	function let_(F) {
		return function(name, f) {
			return function(fa) {
				return F.map(fa, function(a) {
					var _a;
					return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
				});
			};
		};
	}
	/** @deprecated */
	function getFunctorComposition(F, G) {
		var _map = map(F, G);
		return { map: function(fga, f) {
			return (0, function_1.pipe)(fga, _map(f));
		} };
	}
	/** @internal */
	function as(F) {
		return function(self, b) {
			return F.map(self, function() {
				return b;
			});
		};
	}
	/** @internal */
	function asUnit(F) {
		var asM = as(F);
		return function(self) {
			return asM(self, void 0);
		};
	}
}) });

//#endregion
export { require_Apply, require_Chain, require_Functor, require_internal };